import React, { useEffect, useState } from "react";
import "./SpecForm.scss";
import { ManagedInput } from "components/orders/Fields/Input/ManagedInput";
import type { OutsideStepArray } from "./SpecFormSchema";
import { ManagedToggle } from "components/orders/Fields/Toggle/ManagedToggle";
import { useT } from "i18n";

interface OutsideStepProps {
  setOutsideStep: (outsideStep: OutsideStepArray) => void;
  outsideStep: OutsideStepArray | null;
  archived?: boolean;
}

export interface outsideStepValuesType {
  id: string;
  anchorTypeOptions?: string;
  cableAssembly?: boolean;
  isRemovable?: boolean;
  isCovered?: boolean;
  isOverWater?: boolean;
  notes?: string;
}

const OutsideStep = ({ outsideStep, setOutsideStep, archived }: OutsideStepProps) => {
  const t = useT();
  // Field states
  const [outsideStepBool, setOutsideStepBool] = useState<boolean>(
    outsideStep?.outsideStep ?? true,
  );
  const [outsideStepFeatureId, setOutsideStepFeatureId] = useState<string | undefined>(
    outsideStep?.outsideStepFeatureId,
  );
  const [outsideStepWidthSize, setOutsideStepWidthSize] = useState<string | undefined>(
    outsideStep?.outsideStepWidthSize?.toString(),
  );
  const [outsideStepComments, setOutsideStepComments] = useState<string | undefined>(
    outsideStep?.outsideStepComments,
  );

  useEffect(() => {
    setOutsideStep({
      outsideStep: outsideStepBool,
      outsideStepFeatureId: outsideStepFeatureId ?? "",
      outsideStepWidthSize: parseInt(outsideStepWidthSize ?? "0"),
      outsideStepComments: outsideStepComments ?? "",
    });
  }, [
    outsideStepBool,
    outsideStepFeatureId,
    outsideStepWidthSize,
    outsideStepComments,
  ]);

  return (
    <>
      {outsideStepFeatureId && (
        <div className={"spec-form__second-title"}>
          {t("component.forms.spec.featureLabel", "Feature: {{label}}", {
            label: outsideStepFeatureId,
          })}
        </div>
      )}
      <ManagedToggle
        label={t("component.forms.spec.outsideStep", "Outside Step?")}
        name={"Outside Step?"}
        isValid={true}
        onChange={setOutsideStepBool}
        checked={outsideStepBool}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t("component.forms.spec.outsideStepFeatureID", "Outside Step FeatureID")}
        type={"text"}
        placeholder={t(
          "component.forms.spec.outsideStepFeatureID",
          "Outside Step FeatureID",
        )}
        onChange={setOutsideStepFeatureId}
        value={outsideStepFeatureId}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t(
          "component.forms.spec.outsideStepWidthSize",
          "Outside Step Width Size",
        )}
        type={"text"}
        placeholder={t(
          "component.forms.spec.outsideStepWidthSize",
          "Outside Step Width Size",
        )}
        onChange={setOutsideStepWidthSize}
        value={outsideStepWidthSize}
        disabled={archived}
      />
      <ManagedInput
        isValid={true}
        label={t("component.forms.spec.outsideStepComments", "Outside Step Comments")}
        type={"text"}
        placeholder={t(
          "component.forms.spec.outsideStepComments",
          "Outside Step Comments",
        )}
        onChange={setOutsideStepComments}
        value={outsideStepComments}
        disabled={archived}
      />
    </>
  );
};

export default OutsideStep;
